<div class="item-container" *ngIf="config.title">
    <div class="one-item">
        <div class="item-label body-3">
            <label [ngClass]="{'active-span':config.title.clickable}" (click)="onItemClick($event,item)"
                class="item-title">{{config.title}}</label>
        </div>
        <div class="item-value body-1">
            <div class="dont-break-out" *ngFor="let item of config.value;let i = index;trackBy:trackByFn"
                [attr.tid]="config.title">
                <span class="angular-with-newlines"
                    [ngClass]='{"active-span":(item.clickable && item.value !== "******")}'
                    (click)="onItemClick($event,item)">{{item.value}}<span *ngIf="i < config.value.length-1">, </span>
                </span>
                <span *ngIf="config.description" class="item-label body-3">{{item.description}}</span>
            </div>
        </div>
    </div>
</div>